import React from 'react'

const Footer = () => {
  return <footer className="py-12 bg-gray-900"></footer>
}
export default Footer
